<template>
  <!-- LA: Remove on a linked account used to unlink at once, with no question -->
  <Dialog
    :visible="visible"
    header="Confirm"
    :style="{ width: '380px' }"
    :modal="true"
    @update:visible="val => $emit('update:visible', val)"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span>Remove the link to {{ branchLabel }}?</span>
    </div>
    <template #footer>
      <Button label="No" icon="pi pi-times" class="p-button-text" @click="$emit('update:visible', false)" />
      <Button label="Yes" icon="pi pi-check" class="p-button-text p-button-danger" autofocus @click="$emit('confirm')" />
    </template>
  </Dialog>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    account: { type: Object, default: null }
  },
  computed: {
    branchLabel() {
      const a = this.account || {}
      const branch = a.branchName || a.branchCode || 'this branch'
      return a.tasCode ? `${branch} (TAS ${a.tasCode})` : branch
    }
  }
}
</script>
